import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCheckmark = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 13,
	height: 14,
	viewBox: "0 0 13 14",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#clip0_9447_26477)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M11.9911 2.88135C12.3329 3.22314 12.3329 3.77822 11.9911 4.12002L4.99111 11.12C4.64932 11.4618 4.09424 11.4618 3.75244 11.12L0.252441 7.62002C-0.0893555 7.27822 -0.0893555 6.72314 0.252441 6.38135C0.594238 6.03955 1.14932 6.03955 1.49111 6.38135L4.37314 9.26064L10.7552 2.88135C11.097 2.53955 11.6521 2.53955 11.9938 2.88135H11.9911Z",
			fill: "#0EAFAF"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_9447_26477",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M0 0H12.25V14H0V0Z",
			fill: "white"
		})
	}) })]
});
export default SvgCheckmark;
